<template>
  <h3 class="title-class my-auto ma-0 pa-0 ">
    {{ title }}
  </h3>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style scoped>
.title-class {
  color: #586271;
  font-weight: bold !important;
  font-size: x-large;
}
</style>